import React from 'react';
import { NavigationItemMenuModel, TNavigationItemModel } from './models/navigationItem.model';
import NavigationItemMenu from '../navigationItemMenu';
import NavigationItemLink from '../navigationItemLink';

const NavigationItem = ({ model }: { model: TNavigationItemModel }) => {
  if (model instanceof NavigationItemMenuModel) {
    return <NavigationItemMenu model={model} />;
  }
  return <NavigationItemLink model={model} />;
};

export default NavigationItem;
